import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const TEAM_MEMBER_USER_PROFILE_FRAGMENT = graphql`
  fragment teamMemberUserProfileFragment on UserProfile {
    firstName
    lastName
  }
`;

export const TEAM_MEMBER_CONTACT_FRAGMENT = graphql`
  fragment teamMemberContactFragment on ContactTeamMember {
    id
    contact {
      ...contactFragment
    }
    createdAt
    updatedAt
    deletedAt
  }
`;

export const TEAM_MEMBER_INLINE_FRAGMENT = graphql`
  fragment teamMemberInlineFragment on TeamMember @inline {
    id
    account {
      ...accountBaseInlineFragment
      accountDetailConnect {
        ...accountConnectDetailInlineFragment
      }
    }
    memberUserId
    contactTeamMembers {
      ...teamMemberContactFragment
    }
    memberUserProfile {
      ...userProfileNameInlineFragment
      ...userProfileBaseInlineFragment
    }
    permissions
    showOnCatalogue
    deletedAt
    updatedAt
    createdAt
  }
`;

export const TEAM_MEMBER_FRAGMENT = graphql`
  fragment teamMemberFragment on TeamMember {
    id
    account {
      ...accountBaseFragment
    }
    memberUserId
    memberUserProfile {
      ...teamMemberUserProfileFragment
      ...userProfileNameInlineFragment
      ...userProfileBaseInlineFragment
    }
    createdAt
  }
`;

export const TEAMS_FRAGMENT = graphql`
  fragment teamsFragment on Team @relay(plural: true) {
    ...teamFragment
  }
`;

export const TEAM_FRAGMENT = graphql`
  fragment teamFragment on Team {
    id
    accountId
    account {
      ...accountBaseFragment
      ...accountDetailsFragment
      ...accountAddressFragment
    }
    members {
      ...teamMemberFragment
    }
  }
`;

export const TEAM_INLINE_FRAGMENT = graphql`
  fragment teamInlineFragment on Team @inline {
    id
    accountId
    account {
      ...accountBaseInlineFragment
      ...accountDetailsFragment
      ...accountAddressFragment
    }
    members {
      ...teamMemberInlineFragment
    }
  }
`;

export const TEAM_MEMEBER_INVITATION_FRAGMENT = graphql`
  fragment teamMemberInvitationFragment on TeamMemberInvitation {
    id
    externalRef
    accountId
    account {
      ...accountBaseFragment
    }
    memberUserId
    memberUserProfile {
      ...teamMemberUserProfileFragment
    }
    email
    message
    accepted
    createdAt
    createdByUserProfile {
      ...teamMemberUserProfileFragment
    }
  }
`;

/**
 * Pagination Fragments
 */
export const TEAM_MEMBERS_PAGINATION_FRAGMENT = graphql`
  fragment teamMembersPaginationFragment on Query @refetchable(queryName: "TeamMembersRefetchQuery") {
    teamMembers(first: $first, after: $after, filter: $filter, ordering: $ordering)
      @connection(key: "TeamMembersPaginationFragment_teamMembers")
      @skip(if: $skip) {
      __id
      count
      edges {
        __id
        node {
          ...teamMemberFragment
        }
      }
    }
  }
`;

export const TEAM_MEMBER_INVITATIONS_PAGINATION_FRAGMENT = graphql`
  fragment teamMemberInvitationsPaginationFragment on Query
    @refetchable(queryName: "TeamMemberInvitationsRefetchQuery") {
    teamMemberInvitations(first: $first, after: $after, filter: $filter, ordering: $ordering)
      @connection(key: "TeamMemberInvitationsPaginationFragment_teamMemberInvitations")
      @skip(if: $skip) {
      __id
      count
      edges {
        __id
        node {
          ...teamMemberInvitationFragment
        }
      }
    }
  }
`;

/**
 * Queries
 */

export const TEAMS_QUERY = graphql`
  query teamsQuery($userId: ID!, $skip: Boolean!) {
    teams(userId: $userId) @skip(if: $skip) {
      teams {
        ...teamInlineFragment
      }
    }
  }
`;

export const TEAM_MEMBERS_QUERY = graphql`
  query teamMembersQuery(
    $first: Int!
    $after: String
    $ordering: [TeamMemberOrdering!]
    $filter: TeamMemberFilter
    $skip: Boolean!
  ) {
    ...teamMembersPaginationFragment
  }
`;
export const TEAM_QUERY = graphql`
  query teamQuery($teamId: ID!) {
    team(id: $teamId) {
      ...teamFragment
    }
  }
`;

export const TEAM_MEMBER_INVITATIONS_QUERY = graphql`
  query teamMemberInvitationsQuery(
    $first: Int!
    $after: String
    $filter: TeamMemberInvitationFilter
    $ordering: [TeamMemberInvitationOrdering!]
    $skip: Boolean!
  ) {
    ...teamMemberInvitationsPaginationFragment
  }
`;

/**
 * Mutations
 */
export const TEAM_MEMBER_DELETE_MUTATION = graphql`
  mutation teamMemberDeleteMutation($id: ID!, $connections: [ID!]!) {
    deleteTeamMember(id: $id) {
      id @deleteEdge(connections: $connections)
    }
  }
`;

export const TEAM_MEMBER_INVITATIONS_BULK_SEND_MUTATION = graphql`
  mutation teamMemberInvitationBulkSendMutation($input: [SendTeamMemberInvitationInput!], $connections: [ID!]!) {
    sendTeamMemberInvitation(input: $input) {
      teamMemberInvitations @prependNode(connections: $connections, edgeTypeName: "Edge") {
        ...teamMemberInvitationFragment
      }
    }
  }
`;

export const TEAM_MEMBER_RESEND_INVITATION_MUTATION = graphql`
  mutation teamMemberResendInvitationMutation($id: ID!) {
    resendTeamMemberInvitation(id: $id) {
      ...teamMemberInvitationFragment
    }
  }
`;

export const TEAM_MEMBER_DELETE_INVITATION_MUTATION = graphql`
  mutation teamMemberDeleteInvitationMutation($id: ID!, $connections: [ID!]!) {
    deleteTeamMemberInvitation(id: $id) {
      id @deleteEdge(connections: $connections)
    }
  }
`;

export const TEAM_MEMBER_INVITATION_ACCEPT_MUTATION = graphql`
  mutation teamMemberInvitationAcceptMutation($id: ID!) {
    acceptTeamMemberInvitation(id: $id) {
      ...teamMemberInvitationFragment
    }
  }
`;
